// extracted by mini-css-extract-plugin
export default {"aboutWrapper":"About_aboutWrapper__lR835","leftContainer":"About_leftContainer__pXI8M","rightContainer":"About_rightContainer__F2uAL"};